/* 🤖 this file was generated by svg-to-ts */
export const matIconKeyboardDoubleArrowRight: {
  name: 'keyboard-double-arrow-right';
  data: string;
} = {
  name: 'keyboard-double-arrow-right',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M6.41 6 5 7.41 9.58 12 5 16.59 6.41 18l6-6z"/><path d="m13 6-1.41 1.41L16.17 12l-4.58 4.59L13 18l6-6z"/></svg>`
};
